export const specialsInitialValues = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    location: '',
};
